import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloud: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCloud"><Path d="M12 4C9.14187 4 6.68595 5.71241 5.59824 8.16485C2.96041 8.79651 1 11.1686 1 14C1 17.3137 3.68629 20 7 20H18C20.7614 20 23 17.7614 23 15C23 12.5603 21.2527 10.5287 18.9412 10.0884C18.4944 6.65314 15.5571 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloud;
